module.exports = __webpack_public_path__ + "static/background-2400765_1920-327add3171a2a510744c77ad7bc6a1ec.jpg";